export default "__VITE_PUBLIC_ASSET__11b51ac2__"